const SadAccueil = () => import('@/components/SadAccueil/SadAccueil.vue')
const Error = () => import('@/core/error/error.vue')

export default [
  {
    path: '/',
    name: 'Accueil',
    component: SadAccueil
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Error,
    meta: {error403: true}
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: Error,
    meta: {error404: true}
  }
]
